export default "__VITE_ASSET__BdBEwKq0__"